<template>
    <q-header class="bg-white" style="border-bottom: 1px solid #E2E8F0;" role="banner">
        <q-toolbar class="mkt-container q-py-sm" style="max-width:1200px;margin:0 auto;">
            <a href="/" class="text-no-decoration row items-center" aria-label="eSign Launchpad - home">
                <img src="/img/logo-nav.webp" alt="eSign Launchpad" width="120" height="32" style="height: 32px; width: auto;" />
            </a>
            <q-space />

            <!-- Desktop nav -->
            <nav class="row items-center q-gutter-md mkt-hide-mobile" aria-label="Primary">
                <a v-for="item in navItems" :key="item.label"
                   :href="item.href"
                   :class="activeClassFor(item)"
                   :aria-current="isActive(item) ? 'page' : null"
                   style="font-size:14px;">{{ item.label }}</a>

                <template v-if="isAuthenticated">
                    <q-btn color="primary" label="My Dashboard" href="/Dashboard" no-caps unelevated size="md"
                           icon="dashboard" class="q-ml-md" style="border-radius:8px;" />
                    <a href="/Account/Logout" @click.prevent="logoutClick"
                       class="text-grey-7 text-weight-medium text-no-decoration q-ml-sm" style="font-size:13px;">Logout</a>
                </template>
                <template v-else>
                    <a href="/Account/Login" class="text-grey-8 text-weight-medium text-no-decoration q-ml-md" style="font-size:14px;">Sign In</a>
                    <q-btn color="primary" label="Get Started Free" href="/Account/Register" no-caps unelevated size="md"
                           class="q-ml-sm" style="border-radius:8px;" />
                </template>
            </nav>

            <q-btn flat dense round icon="menu" color="grey-8" class="lt-md"
                   aria-label="Open navigation menu"
                   :aria-expanded="mobileNavOpen ? 'true' : 'false'"
                   aria-controls="mkt-mobile-nav"
                   @click="$emit('toggle-mobile')" />
        </q-toolbar>

        <!-- Mobile drawer -->
        <nav v-if="mobileNavOpen" id="mkt-mobile-nav" class="bg-white q-pa-md lt-md" aria-label="Primary mobile">
            <div class="column q-gutter-sm">
                <a v-for="item in navItems" :key="item.label"
                   :href="item.href"
                   :class="mobileActiveClassFor(item)"
                   :aria-current="isActive(item) ? 'page' : null">{{ item.label }}</a>
                <q-separator />
                <template v-if="isAuthenticated">
                    <a href="/Dashboard" class="text-grey-8 text-no-decoration q-pa-sm">My Dashboard</a>
                    <a href="/Account/Logout" @click.prevent="logoutClick" class="text-grey-8 text-no-decoration q-pa-sm">Logout</a>
                </template>
                <template v-else>
                    <a href="/Account/Login" class="text-grey-8 text-no-decoration q-pa-sm">Sign In</a>
                    <q-btn color="primary" label="Get Started Free" href="/Account/Register" no-caps unelevated class="q-mt-sm" />
                </template>
            </div>
        </nav>
    </q-header>
</template>

<script>
/**
 * Shared marketing-site top navigation.
 *
 * Keep the `navItems` array in this one place; every marketing page that
 * imports <marketing-nav> gets the same link set automatically. Historical
 * note: the nav used to be inlined per-page, which caused 13 files to drift
 * whenever labels changed.
 *
 * Active-link highlighting is keyed off the current pathname. Each nav item
 * can declare one or more `activePaths` it considers "current".
 */
import { logout } from '@services/authActions.js';

export default {
    name: 'MarketingNav',
    props: {
        mobileNavOpen: { type: Boolean, default: false }
    },
    emits: ['toggle-mobile'],
    data() {
        return {
            isAuthenticated: typeof _AUTHENTICATED !== 'undefined' && _AUTHENTICATED === true,
            navItems: [
                { label: 'Features',                     href: '/Home/Features',                 activePaths: ['/Home/Features'] },
                { label: 'Individuals',                  href: '/Home/Individuals',              activePaths: ['/Home/Individuals'] },
                { label: 'Small Business & Enterprise',  href: '/Home/SmallBusiness',            activePaths: ['/Home/SmallBusiness'] },
                { label: 'Developers',                   href: '/Home/Developers',               activePaths: ['/Home/Developers'] },
                { label: 'Security',                     href: '/Home/Security',                 activePaths: ['/Home/Security'] },
                { label: 'Documentation',                href: '/Docs/IntegrationGuides',        activePaths: ['/Docs'] }
            ]
        };
    },
    computed: {
        currentPath() {
            if (typeof window === 'undefined') return '';
            return window.location.pathname;
        }
    },
    methods: {
        isActive(item) {
            return item.activePaths.some(p =>
                this.currentPath.toLowerCase().startsWith(p.toLowerCase())
            );
        },
        activeClassFor(item) {
            return this.isActive(item)
                ? 'text-primary text-weight-medium text-no-decoration'
                : 'text-grey-8 text-weight-medium text-no-decoration';
        },
        mobileActiveClassFor(item) {
            return this.isActive(item)
                ? 'text-primary text-no-decoration q-pa-sm'
                : 'text-grey-8 text-no-decoration q-pa-sm';
        },
        logoutClick(e) {
            logout(e);
        }
    }
};
</script>

<style scoped>
</style>
